import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { OwnerOverviewComponent } from '../owner-overview/owner-overview.component';
import { LoadingService } from '../../../services/loading.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgIf } from '@angular/common';
import { BreadcrumbComponent } from '../../../elements/breadcrumb/breadcrumb.component';
import { Subscription } from 'rxjs';
import { HttpServiceService } from '../../../services/http-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxToastrService } from '../../../_services/ngx-toastr/ngx-toastr.service';
import { Offcanvas } from 'bootstrap';
import { USER_PERMISSIONS } from '../../../app.constants';
import { LocalStorageService } from '../../../services/local-storage.service';

@Component({
  selector: 'app-owner-bank-details',
  imports: [OwnerOverviewComponent,ReactiveFormsModule, NgIf, BreadcrumbComponent],
  templateUrl: './owner-bank-details.component.html',
  styleUrl: './owner-bank-details.component.css'
})
export class OwnerBankDetailsComponent {
  breadcrumbList : any;
  bank_details: boolean = false;
  loadingService = inject(LoadingService);
  bankForm: FormGroup;
  ownerBankDetails : any;
  userId : string = '';
  private updateOwnerBankdetailSubscription? : Subscription;
  private routeSubscription?: Subscription;
  @ViewChild('addEditBankButton') offcanvas!: ElementRef;
  private offcanvasInstance: Offcanvas | null = null;
  addProperty? : string;
  private authService = inject(LocalStorageService);

  constructor(private fb: FormBuilder, private httpService : HttpServiceService, private route: ActivatedRoute, private alertService: NgxToastrService, private router: Router){
    this.routeSubscription =  this.route.paramMap.subscribe(params => {
      this.userId = params.get('id') ?? "";
      let userType = params.get('type') ?? "";
      this.breadcrumbList = { 
        breadcrumb_path: userType == "owner" ? "Owners" : "Tenants",
        currentURL: 'Bank Details',
        breadcrumb_url : '/admin/'+ (userType == "owner" ? "owners" : "tenants") 
      }
    });
    this.bankForm = this.fb.group({
      bank_account_name: ['', [Validators.required]],
      bank_account_number: ['', [Validators.required]],
      bank_account_type: [null, [Validators.required]],
      bank_name : ['', [Validators.required]],
      bank_ifsc_code : ['', [Validators.required]],
      bank_branch : ['', [Validators.required]],
      bank_phone : [''],
      // address_line1 : [''],
      // address_line2 : [''],      
    });
  }

  ngAfterViewInit() {
        setTimeout(() => {
          const offcanvasElement = this.offcanvas?.nativeElement;
          if (offcanvasElement) {
            this.offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement, {
              backdrop: 'static', 
              keyboard: false,
            });        
          }
        });
  }

  goBackToList(event : any){    
    this.router.navigate([this.breadcrumbList.breadcrumb_url]);
  }

  onSubmit(){
    if(!this.bankForm.valid) return;
    this.updateOwnerBankdetailSubscription  = this.httpService.editUser(this.bankForm.value , this.userId).subscribe({
      next : (response) => {
        this.ownerBankDetails = this.bankForm.value;
        this.cancel();
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  cancel(){
    this.showHideBankDetails();
    this.bankForm.reset();
    if (this.offcanvasInstance) {
      this.offcanvasInstance.hide();
    }
  }

  showHideBankDetails(){
    this.bank_details = !this.bank_details;
  }

  toggleBankDetails(){
    this.showHideBankDetails();
    if(this.ownerBankDetails?.bank_account_number && this.bank_details) {
      this.bankForm.patchValue(this.ownerBankDetails);
    }
    if (this.offcanvasInstance) {
        this.offcanvasInstance.show();
    }
  }

  getUserDetails(data : any){
    this.ownerBankDetails = data["bank_info"];
  }

  ngOnDestroy(){
    this.updateOwnerBankdetailSubscription?.unsubscribe();
    this.routeSubscription?.unsubscribe();
  }

  get checkUserBankAdd(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_BANK_ADD);
  }

  get checkUserBankEdit(){
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_BANK_UPDATE);
  }

}
